module.exports = __webpack_public_path__ + "img/white_paper12.842c1039.png";